var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import isEmpty from "lodash/isEmpty";
export var useEditUserNameAndEmail = function (initial) {
    var _a = __read(React.useState(initial.name), 2), name = _a[0], setName = _a[1];
    var _b = __read(React.useState(initial.email), 2), email = _b[0], setEmail = _b[1];
    var _c = __read(React.useState({}), 2), errors = _c[0], setErrors = _c[1];
    var validate = function () {
        var validated = {};
        // if (name.length === 0 && email.length === 0) {
        //   validated.name = "Необходимо заполнить логин или почту.";
        //   validated.email = "Необходимо заполнить логин или почту.";
        // }
        //
        // if (email.length > 0 && !isValidEmail(email)) {
        //   validated.email = "Неверный формат почты";
        // }
        setErrors(validated);
        return isEmpty(validated);
    };
    return {
        validate: validate,
        errors: errors,
        name: { value: name, set: setName },
        email: { value: email, set: setEmail },
    };
};
